module.exports = __webpack_public_path__ + "img/82.70f98442.jpg";